import React, { useEffect, useState } from "react";
import FeaturedJobs from "./FeaturedJobs";
import "../JobDetails/JobDetails.css";
import { JobSearch, post } from "../../config/imagesLink";
import axios from "../../API/axios";
import { getUserConfig } from "../../Services/apiService";
import { Link, useNavigate, useParams } from "react-router-dom";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import ErrorToast from "../ErrorToast";
import moment from "moment";
import ModalForGuest from "../ModalForGuest";
import { Modal } from "react-bootstrap";
import JobApply from "../JobSearch/JobApply";
import DetailJobApply from "./DetailJobApply";
import BookmarkSharpIcon from "@mui/icons-material/BookmarkSharp";
import BookmarkBorderSharpIcon from "@mui/icons-material/BookmarkBorderSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Helmet } from "react-helmet";
import JobApplyModals from "./JobApplyModals";
import { ShimmerDiv } from "@skeleton";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const JobDetails = ({ setShowjobDetails }) => {
  const { JobId } = useParams();
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const ProfilePercent = localStorage.getItem("ProfilePercentage");
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const [bookmarkModal, setBookmarkModal] = useState(false);
  const closeModalData = () => {
    setBookmarkModal(false);
  };
  const [appliedJobId, setAppliedJobId] = useState(false);
  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleCloseModal = () => setShowAppliedModal(false);
  const handleShow = () => setShowAppliedModal(true);
  const userUid = localStorage.getItem("userUid");
  //************************User Profile Stats Start  ************************//
  // const [userPer, setUserPer] = useState([]);
  // const getUserProfilePer = () => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //   };
  //   axios
  //     .post(`UserProfile/GetProfilePercentage`, data)
  //     .then((response) => {
  //       console.log("userprofilestat", response.data.responseData);
  //       const res = response.data.responseData;
  //       setUserPer(res);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   getUserProfilePer();
  // }, [sessionId]);

  //************************User Profile Stats End  ************************//
  const [profileConfig, setProfileConfig] = useState([]);
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const userConfig = async () => {
    try {
      const responseData = await getUserConfig();
      setProfileConfig(responseData);
    } catch (error) {
      if (
        (error.code === "ERR_NETWORK" && sessionId) ||
        (error.code === "ERR_BAD_REQUEST" && sessionId)
      ) {
        setUnauthorisedModal(true);
      }
    }
  };

  const [showResumeModal, setShowResumeModal] = useState(false);

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");

    if (sessionId) {
      (async () => {
        await Promise.all([
          userConfig()
        ]);
      })();
    }
  }, []);

  const [userCcv, setUserCcv] = useState("");
  const AddUserCcv = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`Ccv/AddUserCcv`, data).then((resData) => {
        // console.log('resData', resData.data.responseData);
        setUserCcv(resData.data.responseData);
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorImage, setErrorImage] = useState(false);
  const [Loading, setLoading] = useState(true);

  const [jobData, setJobData] = useState("");
  const JobDetails = async () => {
    setLoading(true);
    try {
      await axios
        .get(`Job/GetJobDetails?DeviceType=Web&JobId=${JobId}&langKey=${language}`)
        .then((resData) => {
          if (resData.status === 204 || resData.status === 400) {
            setErrorImage(true);
            console.log("ssssssss", resData.status);

          } else {
            setLoading(false);

            console.log("resData", resData.data.responseData.viewJob);
            setJobData(resData.data.responseData.viewJob);
          }
        });

    } catch (error) {
      setErrorImage(true);

      console.log(error);
    } finally {
      setLoading(false); // ✅ always stop loading
    }
  };

  useEffect(() => {
    JobDetails();
  }, [JobId]);
  // console.log('jobData', jobData);

  const [savedJobs, setSavedJobs] = useState(new Set());
  // const [jobId, setJobId] = useState('');
  const saveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/SaveJob`, responseData).then((res) => {
        console.log("save post", res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllJobList();
        // setIsSaved(true);
        setSavedJobs((prev) => new Set(prev).add(jobId));
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Save Post End  ************************//

  //************************UnSave Post start  ************************//
  const unsaveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/UnSaveJob`, responseData).then((res) => {
        // console.log(res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllJobList();
        // setIsSaved(false);
        setSavedJobs((prev) => {
          const newSavedJobs = new Set(prev);
          newSavedJobs.delete(jobId);
          return newSavedJobs;
        });
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************UnSave Post End  ************************//
  const now = moment();
  const itemTime = moment.utc(jobData?.creationTime);
  const duration = moment.duration(now.diff(itemTime));

  const years = duration.years();
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  let result = "";

  // if (years > 0) {
  //   result = `${years} year${years > 1 ? "s" : ""} ago`;
  // } else if (months > 0) {
  //   result = `${months} month${months > 1 ? "s" : ""} ago`;
  // } else if (days > 0) {
  //   result = `${days} day${days > 1 ? "s" : ""} ago`;
  // } else if (hours > 0) {
  //   result = `${hours} hour${hours > 1 ? "s" : ""} ago`;
  // } else if (minutes > 0) {
  //   result = `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  // } else {
  //   result = "just now";
  // }
  if (years > 0) {
    result = `${years} ${t("Notifications.Year")} ${t("Notifications.Ago")}`;
  } else if (months > 0) {
    result = `${months} ${t("Notifications.Month")} ${t("Notifications.Ago")}`;
  } else if (days > 0) {
    result = `${days} ${t("Notifications.Day")} ${t("Notifications.Ago")}`;
  } else if (hours > 0) {
    result = `${hours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`;
  } else if (minutes > 0) {
    result = `${minutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`;
  } else {
    result = t("Notifications.Just Now");
  }


  console.log(result);

  //************************Apply and unapply job  ************************//
  const [showModal, setShowModal] = useState(false);
  const [isappliedF, setIsappliedF] = useState(false);

  const applyNew = async () => {
    try {
      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: JobId,
        type: 1,
        userUid: userUid,
        langKey: language === "en" ? "" : language,
        // hiringStatus: 1,
        // rateType: 1,
        // isRead: true,
      };
      // console.log('body', body);
      const res = await axios.post("/JobAction/ApplyJob", body);
      setToastMessage(res.data.message);
      setShowToast(true);
      JobDetails();
      // closeModal();
      // setJobList([]);
      // getAllJobList(page);
      // setAppliedId(jobId);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const unapplyNew = async (jobId) => {
    try {
      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: JobId,
        type: 1,
        userUid: userUid,
        langKey: language === "en" ? "" : language,
        // hiringStatus: 1,
        // rateType: 1,
        // isRead: true,
      };
      const res = await axios.post("/JobAction/UnApplyJob", body);
      setToastMessage(res.data.message);
      setShowToast(true);
      handleCloseModal();
      JobDetails()
    } catch (e) {
      console.log(e.response.data.message);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Apply and unapply job  ************************//
  console.log("JobSearch", jobData);

  useEffect(() => {
    if (showAppliedModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showAppliedModal]);

  console.log("jobData", jobData);

  const [showToolbar, setShowToolbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowToolbar(true);
      } else {
        setShowToolbar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [jobModalOpen, setJobModalOpen] = useState(false);
  const [jobAction, setJobAction] = useState('')
  const handleJobApply = () => {
    setJobModalOpen(true);
  };

  const cleanShortDescription = (htmlString) => {
    return htmlString
      ?.replace(/<h3>/gi, "<div>")
      ?.replace(/<\/h3>/gi, "</div>")
      ?.replace(/<strong>/gi, "")
      ?.replace(/<\/strong>/gi, "");
  };

  return (
    <>
      <Helmet>
        <title>{`${jobData?.title}`} | Welinkjobs</title>
        <meta name="description" content={`${jobData?.fullDescription}`} />
        <meta name="keywords" content="newsfeed, updates, latest news" />
        <meta
          property="og:title"
          content={`${jobData?.title} Profile | Welinkjobs`}
        />
        <meta
          property="og:description"
          content={`${jobData?.fullDescription}`}
        />
        <meta property="og:url" content="https://welinkjobs.com/NewsFeeds" />
      </Helmet>

      {Loading ? (
        <div className="p-lg-5 p-md-3 p-3 mt-5">
          <div className="row mt-3 jobdetail-sideLinks">
            <div className="col-md-6 jobdetail-left">
              <ShimmerDiv height={580} width={"100%"} />
            </div>
            <div className="col-md-6 jobdetail-right">
              <ShimmerDiv height={200} width={"100%"} />
            </div>
          </div>
        </div>

      ) :
        errorImage ? (
          <div className="mt-5 text-center ">
            <img src={post.errorSmall} alt="404 Not Found" width={300} className="mt-5" />
          </div>
        ) :
          (
            <>
              <div className="p-lg-5 p-md-3 p-3 mt-5">
                <div className="row mt-3 jobdetail-sideLinks">
                  <div className="col-md-6 jobdetail-left">
                    <div className="SingleJob">

                      <div className="job-detail-bgimag">
                        <img
                          src={jobData?.compBackgroundImage}
                          alt="Loading job background image..."

                        />
                      </div>

                      <div className="company-sub-image">
                        <Link to={`/Company/${jobData.compUid}`}>
                          <img
                            src={jobData?.compLogo}
                            alt=""
                            srcset=""
                            // width={150}
                            // height={50}
                            style={{ borderRadius: "50px" }}
                          />
                        </Link>
                      </div>
                      <div className="single-job-main-content p-3 mt-3">
                        <div className="singlejob-cont">
                          <div className="singlejob-header d-flex justify-content-between singlejobnew-header">
                            <div className="lead-product-text f-20 f-600 d-flex flex-column">
                              <Link to={`/Company/${jobData.compUid}`}>
                                <span className="JobTitlenewMain">{jobData.compName}</span>
                              </Link>
                              <div className="JobTitlenew">{jobData?.title}</div>
                            </div>

                            <div className="lead-product-right">
                              {savedJobs.has(jobData?.jobId) ||
                                jobData?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction">
                                  {/* <span
                            className="material-symbols-sharp pointer"
                            onClick={() => {
                              if (guestModeData !== "true") {
                                unsaveJob(jobData?.jobId);
                              }
                            }}
                            disabled={guestModeData === "true"}
                          >
                            bookmark
                          </span> */}
                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  {/* <span
                            className="material-symbols-outlined pointer"
                            onClick={() => {
                              if (guestModeData !== "true") {
                                saveJob(jobData?.jobId);
                              }
                            }}
                            disabled={guestModeData === "true"}
                          >
                            bookmark
                          </span> */}
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="singlejob-sub-header d-flex justify-content-between mt-2">
                            <div className="lead-product-text f-12 f-500">
                              {jobData.locationName}{" "}
                              <span className="f-12 f-400">{jobData.cityName}</span>
                            </div>
                            <div className="post-text f-12 f-400">
                              <Tooltip title={moment.utc(jobData?.creationTime).local().format("DD MMM YYYY")} arrow>
                                <span className="f-12 f-400 me-2 ChangeColor">{t("Manage Job.Posted")} {result}</span>
                              </Tooltip>
                              <div className="badge badge-date">
                                {Number(jobData?.expiringInDays) < 0
                                  ? `${t("Manage Job.expired")} ${Math.abs(Number(jobData?.expiringInDays))} ${t("Manage Job.days Ago")}`
                                  : `${jobData?.expiringInDays} ${t("Manage Job.days Left")}`}
                              </div>
                            </div>
                          </div>

                          <div className="singlejob-sub-header d-flex justify-content-between mt-2">
                            <div className="lead-product-text"></div>
                            <div className="lead-product-text f-12 f-500">
                              {t("Newsfeed.Designation")}
                              <span className="f-12 f-400 ms-2 ChangeColor badge badge-Details">
                                {jobData?.designationName}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="employee-details d-flex justify-content-between mt-4">
                          <div className="employee-custom-details">
                            <h6 className="f-12">{t("SearchJob.Work Location")} </h6>
                            <h2 className="f-12 f-500 badge badge-Details">
                              {jobData?.workLocationTypeName}
                            </h2>
                          </div>
                          <div className="employee-custom-details">
                            <h6 className="f-12">{t("Newsfeed.Work Level Type")}</h6>
                            <h2 className="f-12 f-500 badge badge-Details">{jobData.workLevelTypeName}</h2>
                          </div>
                          <div className="employee-custom-details">
                            <h6 className="f-12">{t("Newsfeed.Job Type")}</h6>
                            <h2 className="f-12 f-500 badge badge-Details">{jobData?.jbTypName}</h2>
                          </div>

                          <div className="employee-custom-details">
                            <h6 className="f-12">{t("Newsfeed.Salary Type")}</h6>
                            <h2 className="f-12 f-500 badge badge-Details">
                              {jobData?.salaryDisplay === null
                                ? "N.A"
                                : `${jobData?.salaryDisplay} `}
                                {/* : `$${jobData?.maxSalary} / ${jobData?.salaryTypeName}`} */}
                            </h2>
                          </div>
                        </div>

                        <div className="overview-cont mt-4">
                          <h3 className="f-14 f-600">{t("Newsfeed.Job Description")}</h3>
                          <div
                            className="overviewDescription fst-italic"
                            dangerouslySetInnerHTML={{
                              __html: cleanShortDescription(
                                jobData?.fullDescription
                              ),
                            }}
                            style={{ fontSize: "12px", lineHeight: "1.5" }}
                          />
                          {/* <p className="f-12 f-400">{jobData.fullDescription}</p> */}
                        </div>
                        <hr />

                        <div className="single-job-bottom-cont d-flex justify-content-between align-items-center">
                          <div className="apply-que-text ChangeTextSize">
                            {jobData?.isOwned !== true ? (
                              <h2 className="f-14 f-600 m-0">
                                {t("Newsfeed.Are you Interested in this Jobs")}
                              </h2>
                            ) : (
                              <div className="badge badge-job1 me-3">
                                {t("Newsfeed.You Owned this company")}
                              </div>
                            )}
                          </div>
                          {jobData && (
                            <DetailJobApply
                              isAppliedByYou={jobData?.isApplied}
                              jobId={jobData?.jobId}
                              getAllJobList={JobDetails}
                              item={jobData}
                              profileConfig={profileConfig}
                              // userPer={userPer}
                              AddUserCcv={AddUserCcv}
                              userCcv={userCcv}
                            />
                          )}
                        </div>
                      </div>

                      <div
                        className={`fixed_Scrollbar-UserDetail-Toolbar fixed_Scrollbar-UserDetail-Toolbar3 ${showToolbar ? "show" : "hide"
                          }`}
                      >
                        <div className="fixed_Scrollbar-UserDetail-ToolbarInner">
                          <div className="fixed_Scrollbar-UserDetail-Toolbar_Details">
                            <div className="fixed_Scrollbar-UserDetail-Toolbar_UserIconBothfixed_Scrollbar-UserDetail-Toolbar_User_Details">
                              <div className="fixed_Scrollbar-UserDetail-Toolbar_UserIcon">
                                <div className={`profileImg fixed_Scroll`}>
                                  <Link to={`/Company/${jobData.compUid}`}>
                                    <img src={jobData?.compLogo} alt="" srcset="" />
                                  </Link>
                                </div>
                              </div>
                              <div className="fixed_Scrollbar-UserDetail-Toolbar_User_Details">
                                <Link to={`/Company/${jobData.compUid}`}>
                                  <h4>{jobData.compName}</h4>
                                  <div>{jobData?.title}</div>
                                </Link>
                                <span className="f-12 f-400 d-block ChangeColor">
                                  {jobData.cityName}
                                </span>
                              </div>
                            </div>
                            <div className="fixed_Scrollbar-UserDetail-Toolbar_Buttons  fixed_Scrollbar-UserDetail-Toolbar_ButtonsNone">
                              <div className="JobDetailsFixedbtn">
                                <button className="mainBtn appliedBtn"
                                  //  onClick={() =>
                                  //           guestModeData === "true"
                                  //               ? setBookmarkModal(true)
                                  //               : (profileConfig.hasCcv === null || profileConfig.hasCcv !== true) ||
                                  //                  ProfilePercent < 60
                                  //                   ? handleJobApply()
                                  //                   : applyNew()
                                  //       }
                                  onClick={() => {
                                    if (guestModeData === "true") {
                                      return setBookmarkModal(true);
                                    }
                                    if (
                                      profileConfig.hasCcv === null ||
                                      profileConfig.hasCcv !== true ||
                                      ProfilePercent < 60
                                    ) {
                                      return handleJobApply();
                                    }
                                    if (jobData?.isApplied) {
                                      setShowAppliedModal(true);
                                    } else {
                                      return applyNew();
                                    }
                                  }}

                                // onClick={handleJobApply}
                                >{jobData?.isApplied ? (<>
                                  <span className="default-text">{t("Manage Job.Applied")}</span>
                                  <span className="hover-text">{t("Manage Job.Unapply")}</span></>) :
                                  t("SearchJob.Apply Now")}</button>
                              </div>

                              {savedJobs.has(jobData?.jobId) ||
                                jobData?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          <div className=" d-flex align-items-center justify-content-between flex-wrap">
                            <Tooltip title={moment.utc(jobData?.creationTime).local().format("DD MMM YYYY")} arrow>
                              <span className="f-12 f-400 me-2 ChangeColor">{t("Manage Job.Posted")} {result}</span>
                            </Tooltip>
                            <div className="lead-product-text f-12 f-500">
                              {t("Newsfeed.Designation")}
                              <span className="f-12 f-400 ms-2 ChangeColor">
                                {jobData?.designationName}
                              </span>
                            </div>
                          </div>
                          <div className="fixed_Scrollbar-UserDetail-Toolbar_Buttons  fixed_Scrollbar-UserDetail-Toolbar_ButtonsSmallDevice d-lg-none d-md-none">
                            <div className="fixed_Scrollbar-UserDetail-Toolbar_ButtonsSmallDevice_INNER">
                              <div className="JobDetailsFixedbtn">
                                <button className="mainBtn appliedBtn"
                                  onClick={() =>
                                    guestModeData === "true"
                                      ? setBookmarkModal(true)
                                      : (profileConfig.hasCcv === null || profileConfig.hasCcv !== true) ||
                                        ProfilePercent < 60
                                        ? handleJobApply()
                                        : applyNew()
                                  }
                                // onClick={handleJobApply}
                                >{jobData?.isApplied ? (<>
                                  <span className="default-text">{t("Manage Job.Applied")}</span>
                                  <span className="hover-text">{t("Manage Job.Unapply")}</span></>) :
                                  t("Manage Job.Apply Now")}</button>
                              </div>

                              {savedJobs.has(jobData?.jobId) ||
                                jobData?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction">
                                  {/* <span
                            className="material-symbols-sharp pointer"
                            onClick={() => {
                              if (guestModeData !== "true") {
                                unsaveJob(jobData?.jobId);
                              }
                            }}
                            disabled={guestModeData === "true"}
                          >
                            bookmark
                          </span> */}

                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  {/* <span
                            className="material-symbols-outlined pointer"
                            onClick={() => {
                              if (guestModeData !== "true") {
                                saveJob(jobData?.jobId);
                              }
                            }}
                            disabled={guestModeData === "true"}
                          >
                            bookmark
                          </span> */}
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(jobData?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 jobdetail-right">
                    <FeaturedJobs JobId={JobId} JobDetails={JobDetails} />
                  </div>
                </div>
              </div>
            </>
          )
      }

      {bookmarkModal && <ModalForGuest closeModalData={closeModalData} />}

      {showAppliedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>Are you sure want to unapply ?</h6>

                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>
              <div className="col-md-12 text-end mt-4 d-flex justify-content-center">
                <button
                  type="button"
                  className="mainBtn1"
                  onClick={() => unapplyNew(JobId)}
                >
                  UnApply
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal);
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem("hasModalShown");
                      }}
                    >
                      {t("modals.login")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {jobData && jobModalOpen && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Please complete your profile up to 60% and must have valid resume to  Create Company")}</h6>

                {/* <span
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        setShowResumeModal(false);
                                    }}
                                >
                                    close
                                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setJobModalOpen(false);
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <Link to={`/User/${userUid}`}>
                  <button
                    color=""
                    className="closebtn"
                    style={{ width: "150px" }}
                  // onClick={() => {
                  //     userCcv !== "True" && AddUserCcv();
                  // }}
                  >
                    Manage Profile
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        // <JobApplyModals
        //   action={jobData?.isApplied ? 'unapply' : 'apply'}
        //   showApplyModal={jobModalOpen}
        //   onActionClose={()=>setJobModalOpen(true)}
        //   isAppliedByYou={jobData?.isApplied}
        //   jobId={jobData?.jobId}
        //   getAllJobList={JobDetails}
        //   item={jobData}
        //   profileConfig={profileConfig}
        //   // userPer={userPer}
        //   AddUserCcv={AddUserCcv}
        //   userCcv={userCcv}
        // />
      )}
    </>
  );
};

export default JobDetails;
